import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import { getRPAChargeCodesMappedApi } from 'api';
import useLocalStorageTableCells from 'hooks/useLocalStorageTableCells';
import useStyles from '../styles';
import { defaultTableCells } from './helpers/mapped';
import DataMappingTableHeadRow from './DataMappingTableHeadRow';
import DataMappingTableRow from './DataMappingTableRow';
import DataMappingTableToolbar from './DataMappingTableToolbar';


const DataMappingTable = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { headTableCells, setHeadTableCells } = useLocalStorageTableCells('DataMappingTableCells', defaultTableCells);
  const [sort, setSort] = useState({fieldName: 'charge_code_updated_at_sort', sortDirection: 'desc'});
  const [search, setSearch] = useState({searchField: '', searchValue: ''});
  const [filters, setFilters] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const {
    chargeCodesMapped,
    chargeCodesMappedTotalCount,
    isChargeCodesMappedLoading
  } = useSelector((state: IReduxState) => state.rpa);

  useEffect(() => {
    getRPAChargeCodesMappedApi({
      dispatch,
      sort,
      search,
      filters,
      currentPage,
      rowsPerPage
    });
  }, [sort, search, filters, currentPage, rowsPerPage]);

  const handleRequestSort = (_, property) => {
    const {fieldName, sortDirection} = sort;
    const isDesc = fieldName === property && sortDirection === 'desc';
    setSort(() => ({fieldName: property, sortDirection: isDesc ? 'asc' : 'desc'}));
  };

  const onSearch = (searchValue, searchField) => {
    setSearch({searchField, searchValue});
    setCurrentPage(1);
  };

  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  return (
    <div>
      <TableContainer className={classes.table}>
        <DataMappingTableToolbar
          search={search}
          onSearch={onSearch}
          filters={filters}
          setFilters={setFilters}
          tableCells={headTableCells}
          setHeadTableCells={setHeadTableCells}
        />
        <Table className={classes.table}>
          <TableHead>
            <DataMappingTableHeadRow
              sort={sort}
              headTableCells={headTableCells}
              handleRequestSort={handleRequestSort}
            />
          </TableHead>
          <TableBody>
            {chargeCodesMapped.length ?
              chargeCodesMapped.map((chargeCode) => (
                <DataMappingTableRow
                  key={chargeCode.id}
                  chargeCode={chargeCode}
                  headTableCells={headTableCells}
                  sort={sort}
                  search={search}
                  filters={filters}
                  currentPage={currentPage}
                  rowsPerPage={rowsPerPage}
                />
              ))
              :
              <TableRow>
                <TableCell colSpan={12}>
                  <p className="text-center text-muted">No mapping data.</p>
                </TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
      {!!chargeCodesMappedTotalCount &&
        <TablePagination
          rowsPerPageOptions={[10, 20, 40, 80, 100]}
          component="div"
          className={classes.paginationContainer}
          count={chargeCodesMappedTotalCount}
          rowsPerPage={rowsPerPage}
          page={currentPage - 1}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      }
      <BackdropCircular loading={isChargeCodesMappedLoading} />
    </div>
  );
};

export default DataMappingTable;
